/**
 * Persistance du compteur de pièces (SYS-B-01) — par tenant + exercice.
 */
import { SecureTenantStore } from '@infra/persistence/SecureTenantStore';
import type { CompteurPieces } from '@domain/comptabilite/NumerotationPieces';

function key(exercice: string): string {
  return `compta.compteur_pieces.${exercice}`;
}

export async function loadCompteurPieces(tenantId: string, exercice: string): Promise<CompteurPieces> {
  const raw = await SecureTenantStore.getJson<CompteurPieces>(tenantId, key(exercice), { dernier: 0 });
  const dernier = typeof raw?.dernier === 'number' && raw.dernier >= 0 ? raw.dernier : 0;
  return { dernier };
}

export async function saveCompteurPieces(
  tenantId: string,
  exercice: string,
  compteur: CompteurPieces,
): Promise<CompteurPieces> {
  const safe: CompteurPieces = { dernier: Math.max(0, Math.floor(compteur.dernier)) };
  await SecureTenantStore.setJson(tenantId, key(exercice), safe);
  return safe;
}
